if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.upsellVariantId = this.dataset.upsellVariantId;
        this.grabadoVariantId = 56881218846985;

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      getSectionScope() {
        return this.closest('.shopify-section') || document;
      }

      getGrabadoElements() {
        const scope = this.getSectionScope();
        const wrapper = scope.querySelector('#grabado_wrapper');

        return {
          scope,
          wrapper,
          radios: scope.querySelectorAll('input[name="properties[Grabado trasero]"]'),
          textInput: scope.querySelector('#grabado_texto'),
        };
      }

      ensureHiddenInput(name) {
        let input = this.form.querySelector(`input[name="${name}"]`);
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          this.form.appendChild(input);
        }
        return input;
      }

      syncGrabadoPropertiesIntoForm() {
        const grabado = this.getGrabadoElements();

        if (!grabado.wrapper) {
          return { isPersonalizable: false, selectedValue: 'No', texto: '' };
        }

        const selected = grabado.scope.querySelector('input[name="properties[Grabado trasero]"]:checked');
        const selectedValue = selected ? selected.value : 'No';
        const texto = grabado.textInput ? grabado.textInput.value : '';

        this.ensureHiddenInput('properties[_producto_personalizable_grabado]').value = 'true';
        this.ensureHiddenInput('properties[Grabado trasero]').value = selectedValue;
        this.ensureHiddenInput('properties[Texto grabado trasero]').value =
          selectedValue === 'Sí (+6 €)' ? texto : '';

        return {
          isPersonalizable: true,
          selectedValue,
          texto,
        };
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');

        const spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const grabadoState = this.syncGrabadoPropertiesIntoForm();

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        this.skipCart = false;
        const idInput = this.form.querySelector('[name=id]');
        if (idInput && idInput.dataset.skipCart && idInput.dataset.skipCart === 'true') {
          this.skipCart = true;
        }

        const grabadoSeleccionado =
          grabadoState.isPersonalizable && grabadoState.selectedValue === 'Sí (+6 €)';

        const textoGrabado = grabadoState.texto || '';
        const cantidadProducto = parseInt(formData.get('quantity') || '1', 10) || 1;

        if (grabadoSeleccionado && textoGrabado.trim() === '') {
          this.handleErrorMessage(
            'Has seleccionado grabado trasero. Escribe el texto que quieres grabar para continuar.'
          );
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) {
            this.cart.classList.remove('is-empty');
          }
          this.submitButton.removeAttribute('aria-disabled');
          if (spinner) spinner.classList.add('hidden');
          return;
        }

        fetch(`${routes.cart_url}.js`)
          .then((response) => response.json())
          .then((cartState) => {
            const promises = [];

            if (cartState.item_count === 0 && this.upsellVariantId) {
              promises.push(fetch(`${routes.cart_add_url}`, this.getUpsellProductConfig()));
            }

            if (grabadoSeleccionado) {
              promises.push(
                fetch(
                  `${routes.cart_add_url}`,
                  this.getGrabadoProductConfig(cantidadProducto, textoGrabado)
                )
              );
            }

            return Promise.all(promises);
          })
          .then(() => fetch(`${routes.cart_add_url}`, config))
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });

              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;

              this.submitButton.setAttribute('aria-disabled', true);
              const buttonSpan = this.submitButton.querySelector('span');
              if (buttonSpan) buttonSpan.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (this.skipCart) {
              window.location = '/checkout';
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            }

            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');

            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            if (spinner) spinner.classList.add('hidden');
          });
      }

      getUpsellProductConfig() {
        const upsellFormData = new FormData();
        upsellFormData.append('id', this.upsellVariantId);
        upsellFormData.append('quantity', 1);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = upsellFormData;

        return config;
      }

      getGrabadoProductConfig(quantity, textoGrabado) {
        const grabadoFormData = new FormData();
        grabadoFormData.append('id', this.grabadoVariantId);
        grabadoFormData.append('quantity', quantity);
        grabadoFormData.append('properties[Tipo de recargo]', 'Grabado trasero');
        grabadoFormData.append('properties[Texto grabado trasero]', textoGrabado);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = grabadoFormData;

        return config;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}